/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BulkAssociateResourceWithClient } from './BulkAssociateResourceWithClient';
import {
    BulkAssociateResourceWithClientFromJSON,
    BulkAssociateResourceWithClientFromJSONTyped,
    BulkAssociateResourceWithClientToJSON,
} from './BulkAssociateResourceWithClient';

/**
 * A payload containing resourceIds to be added to a client entity in bulk
 * @export
 * @interface BulkAssociateResourcesWithClients
 */
export interface BulkAssociateResourcesWithClients {
    /**
     * 
     * @type {Array<BulkAssociateResourceWithClient>}
     * @memberof BulkAssociateResourcesWithClients
     */
    associations?: Array<BulkAssociateResourceWithClient>;
}

/**
 * Check if a given object implements the BulkAssociateResourcesWithClients interface.
 */
export function instanceOfBulkAssociateResourcesWithClients(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BulkAssociateResourcesWithClientsFromJSON(json: any): BulkAssociateResourcesWithClients {
    return BulkAssociateResourcesWithClientsFromJSONTyped(json, false);
}

export function BulkAssociateResourcesWithClientsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkAssociateResourcesWithClients {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'associations': !exists(json, 'associations') ? undefined : ((json['associations'] as Array<any>).map(BulkAssociateResourceWithClientFromJSON)),
    };
}

export function BulkAssociateResourcesWithClientsToJSON(value?: BulkAssociateResourcesWithClients | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'associations': value.associations === undefined ? undefined : ((value.associations as Array<any>).map(BulkAssociateResourceWithClientToJSON)),
    };
}

